import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';

const TotalSalesChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (!data || data.length === 0 || !chartRef.current) {
      return;
    }

    const sortedData = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));
    const dates = sortedData.map(item => {
      const date = new Date(item.date);
      return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
    });

    const inrSales = sortedData.map(item => item.total_inr_sales);
    const usdSales = sortedData.map(item => item.total_usd_sales);

    const ctx = chartRef.current.getContext('2d');

    const config = {
      type: 'bar',
      data: {
        labels: dates,
        datasets: [
          {
            label: 'INR Sales',
            data: inrSales,
            backgroundColor: 'rgba(75, 192, 192, 0.5)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
          },
          {
            label: 'USD Sales',
            data: usdSales,
            backgroundColor: 'rgba(153, 102, 255, 0.5)',
            borderColor: 'rgba(153, 102, 255, 1)',
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Total Sales Analysis',
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label || '';
              const value = tooltipItem.yLabel;
              return `${label}: ${value}`;
            },
          },
        },
        legend: {
          position: 'bottom',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Total Sales',
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Date',
              },
            },
          ],
        },
      },
    };

    chartInstance.current = new Chart(ctx, config);

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <div style={{ height: '300px', position: 'relative' }}>
      {data && data.length > 0 ? (
        <canvas ref={chartRef} />
      ) : (
        <div className="text-center pt-5">No data available for the selected period</div>
      )}
    </div>
  );
};

export default TotalSalesChart;
